import React from 'react'
import StaticQuestionSlide from '../../slides/StaticQuestionSlide'
import Icon from '../../misc/Icons'
import QuestionCountBadge from '../../uiKit/QuestionCountBadge'
import { TILE_WIDTH, TILE_HEIGHT } from './previewConstants'

// One tile in the 2-column preview grid. Shape depends on `itemType`:
//   - folder  : icon + folder name (plain bordered tile)
//   - set     : first slide thumbnail + question-count badge (top-right)
//   - question: slide thumbnail (no badge)
// All tiles are pure visuals — no click handlers, no hover affordances —
// because the underlying suggestion / result row is what handles navigation.

function SlideThumb({ question }) {
  if (question && question.bodyHtml) {
    return (
      <StaticQuestionSlide
        question={question}
        stage='ask'
        mode='view'
        displayWidth={TILE_WIDTH - 2}
        previewCard
      />
    )
  }
  return (
    <div className='searchPreviewTile-slidePlaceholder'>
      <QuestionCountBadge color='blueLight' size='medium' questionCount='–' />
    </div>
  )
}

function FolderTile({ folder }) {
  return (
    <div className='searchPreviewTile searchPreviewTile--folder' style={{ width: TILE_WIDTH, height: TILE_HEIGHT }}>
      <div className='searchPreviewTile-folderIcon'>
        <Icon name={folder.readOnly ? 'folder-isbe' : 'folder'} />
      </div>
      <div className='searchPreviewTile-folderName' title={folder.name}>
        {folder.name || 'Untitled Folder'}
      </div>
    </div>
  )
}

function SetTile({ set }) {
  const firstQuestion = Array.isArray(set.questions) && set.questions.length > 0 ?
    set.questions[0] :
    null
  const count = Array.isArray(set.questions) ? set.questions.length : 0
  return (
    <div className='searchPreviewTile searchPreviewTile--set' style={{ width: TILE_WIDTH, height: TILE_HEIGHT }}>
      <div className='searchPreviewTile-slide' style={{ width: TILE_WIDTH, height: TILE_HEIGHT }}>
        <SlideThumb question={firstQuestion} />
      </div>
      <div className='searchPreviewTile-badge'>
        <QuestionCountBadge color='blueLight' questionCount={count > 99 ? '99+' : count} size='small' />
      </div>
    </div>
  )
}

function QuestionTile({ question }) {
  return (
    <div className='searchPreviewTile searchPreviewTile--question' style={{ width: TILE_WIDTH, height: TILE_HEIGHT }}>
      <div className='searchPreviewTile-slide' style={{ width: TILE_WIDTH, height: TILE_HEIGHT }}>
        <SlideThumb question={question} />
      </div>
    </div>
  )
}

// Public: render an ordered list of mixed entries as a flowing 2-column grid.
// Each entry: { id, itemType: 'folder'|'set'|'question', item }
function SearchPreviewTileGrid({ entries }) {
  if (!Array.isArray(entries) || entries.length === 0) return null
  return (
    <div className='searchPreviewTileGrid'>
      {entries.map((entry) => {
        if (!entry || !entry.item) return null
        if (entry.itemType === 'folder') {
          return <FolderTile key={entry.id} folder={entry.item} />
        }
        if (entry.itemType === 'set') {
          return <SetTile key={entry.id} set={entry.item} />
        }
        if (entry.itemType === 'question') {
          return <QuestionTile key={entry.id} question={entry.item} />
        }
        return null
      })}
    </div>
  )
}

export default SearchPreviewTileGrid
